import {ICourseCurriculumItemEntity, IFlatList} from "@buildwitt/shapeshift-types";

export const mapItem = (e: ICourseCurriculumItemEntity, sectionCount: number): IFlatList => {
	if(!e.module){
		const i = ++sectionCount
		return {type: "section", title: e.title ?? "", level: e.level, dragId: "section-" + i, slug: "section-" + i}
	}
	else {
		const {module, level, id, progression, moduleType} = e;

		if(!moduleType)
			throw new Error("invalid ICourseCurriculumItemEntity");

		return {
			type: moduleType,
			slug: module.slug,
			title: module.title,
			level,
			dragId: moduleType + "-" + id,
			moduleId: module.id,
			progression
		}
	}
}

export const initFlatList = (items: ICourseCurriculumItemEntity[]): IFlatList[] => {
	const exportList: IFlatList[] = [];
	let sectionCount = 0;

	items.forEach(e => {
		try{
			const newItem = mapItem(e, sectionCount);
			if(newItem.type === "section")
				sectionCount ++;

			exportList.push(newItem);
		}
		catch(ex){
			// eslint-disable-next-line no-console
			console.error("initFlatList", ex)
		}
	})

	return exportList;
}

export const deleteModule = (flatList: IFlatList[], index: number): IFlatList[] => {
	const _flatList = [...flatList];
	let deleteCount = 1;

	if(flatList[index].collapsedChildren){
		let prev = flatList[index];
		for(let i = (index + 1); i < (flatList.length + 1); i++){
			if(deleteCount === 1 && (i === flatList.length || prev.level > flatList[i].level)){
				deleteCount = (i - index);
				break;
			}
			prev = flatList[i]
		}
	}

	_flatList.splice(index, deleteCount);
	const result = [...validateList(_flatList)]
	return result;
}

//ensure levels are only + 1 in sequence 
//if not, adjust
export const validateList = (flatList: IFlatList[]): IFlatList[] => {
	if(flatList.length > 0 && flatList[0].level > 0){
		flatList[0].level = 0;
	}

	let prevLevel = 0;

	flatList.forEach((e) => {
		if((e.level - prevLevel) > 1){
			e.level = prevLevel + 1;
		}
		prevLevel = e.level;
	})
	return flatList;
}
